import React from "react";
import { Helmet } from "react-helmet-async";
import HeroBanner from "../../../Hero/HeroBanner";
import GoToPriceMultiple from "../GoToPrice/GoToPriceMultiple";
import HeroPicBig from "../../../../../assets/medical/examinations/packages/szures/szures_banner_nagy.png";
import HeroPicSmall from "../../../../../assets/medical/examinations/packages/szures/szures_banner_kicsi.png";
import { examinationPackages } from "../../exams/examinationPackages";
import ExamContent from "../ExamContent/ExamContent";
import ExamCTA from "../../ExamCTA/ExamCTA";

const ExamPackageSzures = () => {
  const szuresPackages = examinationPackages[0].contains;

  // Create structured data for health screening packages
  const screeningPackagesStructuredData = {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Egészségügyi szűrőcsomagok - Bálint Analitika",
    description:
      "A Bálint Analitika laboratórium átfogó egészségügyi szűrőcsomagjai különböző életkorú és egészségi állapotú páciensek számára.",
    relevantSpecialty: [
      "PreventiveMedicine",
      "InternalMedicine",
      "FamilyMedicine",
    ],
    medicineSystem: "Conventional Medicine",
    usedToDiagnose: "General health assessment and early disease detection",
    normalRange: "Varies by individual test",
    affectedBy: ["Age", "Sex", "Lifestyle", "Existing health conditions"],
    procedure: "Comprehensive blood test panels and specialized examinations",
    serviceProvider: {
      "@type": "MedicalBusiness",
      name: "Bálint Analitika Laboratórium",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Kondorfa utca 6.",
        addressLocality: "Budapest",
        postalCode: "1116",
        addressRegion: "XI. kerület",
        addressCountry: "HU",
      },
    },
    offers: {
      "@type": "Offer",
      availability: "InStock",
      priceCurrency: "HUF",
      priceSpecification: {
        "@type": "PriceSpecification",
        price: "Varies by package",
      },
    },
  };

  return (
    <>
      <Helmet>
        <title>
          Egészségügyi szűrővizsgálatok | Átfogó szűrőcsomagok | Bálint
          Analitika
        </title>
        <meta
          name="description"
          content="Átfogó egészségügyi szűrőcsomagok minden korosztály számára a Bálint Analitika budapesti laboratóriumában. Megelőzésre és korai betegségfelismerésre optimalizált vizsgálatok."
        />
        <meta
          name="keywords"
          content="egészségügyi szűrés, laboratóriumi szűrővizsgálat, megelőző vizsgálat, átfogó egészségügyi csomag, vérvizsgálat Budapest, szűrőpanel"
        />
        <link
          rel="canonical"
          href="https://balintanalitika.hu/orvosdiagnosztika/vizsgalatok/csomagok/szurések"
        />
        <script type="application/ld+json">
          {JSON.stringify(screeningPackagesStructuredData)}
        </script>
      </Helmet>

      <HeroBanner
        srcBig={HeroPicBig}
        srcSmall={HeroPicSmall}
        alt="Egészségügyi szűrővizsgálatok és átfogó szűrőcsomagok a Bálint Analitika laboratóriumban"
      />

      <main className="screening-package-page">
        <div className="container">
          <header className="screening-package-header">
            <h1 className="heading-primary">
              Egészségügyi szűrővizsgálat csomagok
            </h1>
            <p className="base-p-text">
              A Bálint Analitika laboratórium átfogó egészségügyi
              szűrőcsomagokat kínál Budapest XI. kerületében, amelyek segítenek
              az egészségi állapot felmérésében és a betegségek korai
              felismerésében. Szakértőink által összeállított szűrőcsomagjaink
              különböző életkorú és egészségi állapotú páciensek igényeire
              szabottak.
            </p>
          </header>

          <section className="screening-package-content">
            <div className="exam-package-benefits">
              <h2 className="heading-secondary mt-0">
                A rendszeres szűrővizsgálatok előnyei
              </h2>
              <ul className="exam-package-base-list">
                <li>
                  Betegségek korai felismerése, amikor még hatékonyabban
                  kezelhetők
                </li>
                <li>Alapos képet ad az általános egészségi állapotról</li>
                <li>Segít a krónikus betegségek megelőzésében</li>
                <li>Személyre szabott egészségügyi tanácsadás alapja lehet</li>
                <li>
                  Rendszeres követéssel nyomon követhetők az egészségi állapot
                  változásai
                </li>
              </ul>
            </div>

            <div className="screening-packages-grid">
              <h2 className="heading-secondary">
                Választható szűrőcsomagjaink
              </h2>
              {szuresPackages.map((packageItem, index) => (
                <article key={index} className="screening-package-item">
                  <ExamContent
                    title={packageItem.name}
                    suggestedTo={packageItem.suggestedTo}
                    items={packageItem.items}
                    isPackage={true}
                    itemType="https://schema.org/MedicalTest"
                  />
                </article>
              ))}
            </div>

            <div className="screening-package-info">
              <h3 className="heading-tertiary">
                Hogyan készüljön a szűrővizsgálatra?
              </h3>
              <p className="base-p-text">
                A legtöbb szűrővizsgálathoz éhgyomri vérvétel szükséges, ezért a
                vizsgálat előtti 12 órában ne fogyasszon ételt. Vizet lehet és
                ajánlott is fogyasztani. Hozza magával személyi igazolványát és
                TAJ kártyáját. A vizsgálat előtt kerülje az intenzív testmozgást
                és az alkoholfogyasztást.
              </p>
            </div>

            <div className="screening-package-actions">
              <GoToPriceMultiple />

              <div
                className="screening-package-contact"
                itemScope
                itemType="https://schema.org/MedicalOrganization"
              >
                <h3 className="heading-tertiary">
                  Konzultáció és időpontfoglalás
                </h3>
                <p className="base-p-text">
                  Szűrővizsgálatainkkal kapcsolatban szakértői konzultációt
                  biztosítunk.
                </p>
                <ExamCTA />
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default ExamPackageSzures;
